/* eslint-disable react-hooks/exhaustive-deps */
import { loadPageBlocks } from 'providers/actions/loadPageBlocks'
import { PagesContext } from 'providers/Pages'
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo
} from 'react'

type SlotsContextProps = {
  slotsPageData: Array<{}>
  sideBoxTabsList: Array<{}>
  handleSideBoxTabs(value: sideBoxTabsListItemProps): void
}

type sideBoxTabsListItemProps = {
  id: string
  name: string
  hidden: boolean
}

export const SlotsContext = createContext<SlotsContextProps>(
  {} as SlotsContextProps
)

export interface SlotsProviderProps {
  children: any;
  disableLoadPage?: boolean;
  initSlotPageData?: Array<any>;
}

const SlotsProvider: React.FC<SlotsProviderProps> = ({ children, disableLoadPage, initSlotPageData = [] }) => {
  const [slotsPageData, setSlotsPageData] = useState(initSlotPageData)
  const [sideBoxTabsList, setSideBoxTabsList] = useState<Array<sideBoxTabsListItemProps>>([{ id: '', name: 'slotLeft', hidden: false }])

  const handleSideBoxTabs = (props: sideBoxTabsListItemProps) => {
  }

  return (
    <SlotsContext.Provider
      value={{
        slotsPageData,
        sideBoxTabsList,
        handleSideBoxTabs
      }}
    >
      {children}
    </SlotsContext.Provider>
  )
}

export default SlotsProvider
